module.exports = __webpack_public_path__ + "assets/img/pantreats_preview.7204feb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/previews/pantreats_preview.png
// module id = 48
// module chunks = 0